module.exports = __webpack_public_path__ + "static/media/mascot.22372b39.svg";